import { useTranslation } from 'react-i18next';

export const LabelName = ({ name }: { name: string }) => {
  const { t } = useTranslation('settings');

  return <span title={t('viewLabelDetails')}>{name}</span>;
};

LabelName.displayName = 'LabelName';
